import { Table } from 'dexie';
import { InspectDatabase } from './database.structure';
import { EquipmentPartModel } from './types';

// isolate this function in its own file (e.g., `insertChunk.ts`)
export async function insertChunk(
  db: InspectDatabase,
  chunk: EquipmentPartModel[],
) {
  await db.transaction('rw', db.equipmentParts, async () => {
    await db.equipmentParts.bulkPut(chunk);
  });
}
